import { CheckIcon, MinusIcon } from '@phosphor-icons/react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';

import { cn } from '@/lib/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-[4px] border border-border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-foreground/80 data-[state=checked]:text-background data-[state=indeterminate]:bg-foreground/80 data-[state=indeterminate]:text-background data-[state=indeterminate]:border-foreground/80',
      className,
    )}
    {...props}
  >
    {/* The glyph is 12px inside a 16px box. It was `h-4 w-4` — the SAME size as
        the box it sits in — so the check filled the control edge to edge with
        no optical padding and read as jammed and off-centre (founder,
        2026-08-23: _"the selected checkbox still isn't correctly selected in
        the box, it's weirdly aligning weird"_). The box positions were always
        correct; measured live, header and every row checkbox sat at x=245. It
        was never alignment — it was a glyph with no room. shadcn ships a
        smaller indicator than its box for exactly this reason. */}
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      {/* Header "select all" reads `checked="indeterminate"` when some — not all —
          rows are selected. Radix renders the Indicator for both states; show a
          minus for partial, a check for full selection. */}
      {props.checked === 'indeterminate' ? (
        <MinusIcon className="size-3" weight="bold" />
      ) : (
        <CheckIcon className="size-3" weight="bold" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = 'Checkbox';

export { Checkbox };
